import OutcomeStatusModel from "./OutcomeStatusModel";
import QuestionModel from "./QuestionModel";

export default class ScopeFilteredModel
{
  public questions: QuestionModel[]
  public status: OutcomeStatusModel[]
}